import { useState, useEffect } from 'react';
import { Menu, X, Phone, Instagram } from 'lucide-react';
import { LOGO_NODULO_FULL, INSTAGRAM_URL } from '../../constants';

const WHATSAPP_NUMBER = '5575981872440';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá, vim do site de nódulo e gostaria de agendar uma consulta com dr. Mateus')}`;

const navLinks = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Nódulo Pulmonar', href: '#nodulo' },
  { label: 'O Que Fazer?', href: '#oque-fazer' },
  { label: 'Convênios', href: '#convenios' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contato', href: '#contato' },
];

export default function NoduloHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleNavClick = () => setIsOpen(false);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-xl shadow-sm border-b border-gray-100'
          : 'bg-white/80 backdrop-blur-xl border-b border-gray-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center flex-shrink-0">
          <img
            src={LOGO_NODULO_FULL}
            alt="Dr. Mateus Marques - Cirurgião Torácico"
            className="h-14 sm:h-16 w-auto object-contain"
            fetchpriority="high"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-[#212121]/70 hover:text-[#0D47A1] font-medium px-3 py-2 rounded-lg hover:bg-[#0D47A1]/5 transition-all duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hidden sm:flex items-center justify-center w-9 h-9 rounded-full text-[#212121]/60 hover:text-[#E1306C] hover:bg-[#E1306C]/10 transition-all duration-200"
          >
            <Instagram size={18} />
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2 bg-[#0D47A1] text-white font-poppins font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-[#00897B] transition-colors duration-200 whitespace-nowrap"
          >
            <Phone size={14} />
            AGENDAR CONSULTA
          </a>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-[#212121] hover:bg-gray-100 transition-colors"
            aria-label="Menu"
          >
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={handleNavClick}
                className="text-[#212121]/80 hover:text-[#0D47A1] font-medium py-3 px-3 rounded-lg hover:bg-[#0D47A1]/5 transition-all duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleNavClick}
              className="mt-2 flex items-center justify-center gap-2 bg-[#0D47A1] text-white font-poppins font-semibold py-3 px-6 rounded-full hover:bg-[#00897B] transition-colors"
            >
              <Phone size={16} />
              AGENDAR CONSULTA
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
